module.exports = __webpack_public_path__ + "media/images/incarcerated_girls/lizard_BW-p-800-4dcad7cd0f0e4ccdce09317e106ac609.jpg";